var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competition"},[_c('el-tabs',{staticClass:"education-content tabs-full",attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"竞赛管理","name":"raceAdmin"}},[_c('competitionManagement')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }